import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  FactFindEntityResponse,
  FactFindInitRequest,
  IAcceptInviteRequest,
  IAcceptInviteResponse,
  IAdvisorOnboardingRequest,
  IAssetPayload,
  IAssetResponseApi,
  IBenefitsAndInsurancePayload,
  IBenefitsAndInsuranceResponseApiResponse,
  IBusinessDetailsResponse,
  ICaptureClientGoalRequest,
  ICaptureFactFindBeneficiaryRequest,
  ICaptureFactfindCHecklistRequest,
  ICaptureFactFindExpenditureRequest,
  ICaptureFactFindExperienceRequest,
  ICaptureFactFindFinancialPlanningRequest,
  ICaptureFactFindIncomeRequest,
  ICaptureFactFindPersonalDetailsRequest,
  ICaptureFactFindRiskAssessmentRequest,
  ICaptureSuitabilityReportSettingRequest,
  IClientDataRequest,
  IClientDataResponse,
  IClientSummaryResponse,
  ICreateFFCoversRequest,
  ICreateFFEmployeeBenefitsRequest,
  ICreatePensionsRequest,
  IDefaultEnumResponse,
  IDeleteRiskAssessmentDocumentPayload,
  IEmptyRequestResponse,
  IFFSummaryCalculateRequest,
  IFFSummaryCalculateResponse,
  IFinancialInformationResponse,
  IGeneratePlanSummaryRequest,
  IGeneratePlanSummaryResponse,
  IGetBusinessOwnershipDetailsResponse,
  IGetQuestionsRequest,
  IGetQuestionsResponse,
  IHealthDetailsApiResponse,
  IHealthInfoPayloadRequest,
  IInvestmentSolutionCaptureRequest,
  IInvestmentSolutionsResponse,
  IInvestorCompanyLookupRequest,
  IInvestorCompanyOfficerLookupResponse,
  IInvestorcompanyLookupResponse,
  IInviteExistingClientRequest,
  IKeyMembersResponse,
  ILiabilitiesCapturePayload,
  ILiabilitiesFactFindResponse,
  IProtectionSolutionCaptureRequest,
  IProtectionSolutionsResponse,
  ISaveAssetsPremiseRequest,
  ISaveBusinessDetailsRequest,
  ISaveFinancialGoalRequest,
  ISaveFinancialInformationRequest,
  ISaveKeyMembersRequest,
  ISaveLoansRequest,
  ISaveProfessionalAdvisorsRequest,
  ISaveRiskQuestionnairePublicRequest,
  ISaveRiskQuestionnaireRequest,
  ISourceDetailRequest,
  ISourceDetailResponse,
  IViewAssetsPremiseRequest,
  IViewAssetsPremiseResponse,
  IViewBusinessDetailsRequest,
  IViewbyAdvisorid,
  IViewClientGoalRequest,
  IViewClientGoalResponse,
  IViewFactFindBeneficiaryRequest,
  IViewfactFindBeneficiaryResponse,
  IViewFactfindChecklistRequest,
  IViewFactfindChecklistResponse,
  IViewFactfindDefaultChecklistResponse,
  IViewFactFindExpenditureResponse,
  IViewFactFindExperienceResponse,
  IViewFactFindFinancialPlanningRequest,
  IViewfactFindFinancialPlanningResponse,
  IViewFactFindIncomeResponse,
  IViewFactFindPersonalDetailsRequest,
  IViewFactFindPersonalDetailsResponse,
  IViewFactFindRequest,
  IViewFactFindRiskAssessmentAnswersResponse,
  IViewFactFindRiskAssessmentRequest,
  IViewFactFindRiskAssessmentResponse,
  IViewFFCoversRequest,
  IViewFFCoversResponse,
  IViewFFEmployeeBenefitsResponse,
  IViewFFPensionRequest,
  IViewFFPensionResponse,
  IViewFinancialGoalsResponse,
  IViewFinancialInformationRequest,
  IViewFinancialPlanListRequest,
  IViewFinancialPlanListResponse,
  IViewGDPRPayload,
  IViewGDPRResponse,
  IViewKeyMembersRequest,
  IViewLoansRequest,
  IViewLoansResponse,
  IViewProfessionalAdvisorsRequest,
  IViewProfessionalAdvisorsResponse,
  IViewRiskQuestionnaireGDPRPublicRequest,
  IViewRiskQuestionnaireGDPRPublicResponse,
  IViewSuitabilityReportSettingResponse,
} from '@zeta-types';

import { CLIENT_ADVICE_SERVICE, INVESTOR_SERVICE } from '../services-path';
import { ICreateInvestorFeeRequest, IViewAMLKYCResponse } from './types';

export * from './types';

export const InvestorService = () => {
  return {
    viewPersonalDetails: (payload: IViewFactFindPersonalDetailsRequest): APIResponse<IViewFactFindPersonalDetailsResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/viewbyid`, payload),

    // beneficiaries
    viewBeneficiaries: (payload: IViewFactFindRequest): APIResponse<IViewfactFindBeneficiaryResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/beneficiary/viewbyid`, payload),

    captureBeneficiaries: (payload: ICaptureFactFindBeneficiaryRequest): APIResponse<IViewFactFindBeneficiaryRequest> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/factfind/beneficiary/save`, payload),

    //
    investorMigrate: (payload: IClientDataRequest | IEmptyRequestResponse): APIResponse<IClientDataResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/migrate`, payload),

    viewbyAdvisorid: (payload: IEmptyRequestResponse): APIResponse<IViewbyAdvisorid> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/migrate/viewby/advisorid`, payload),

    retailClientRegister: (payload: IAdvisorOnboardingRequest): APIResponse<IClientDataResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/prospect/prospectretail/create`, payload),

    // fact find client summary
    viewClientSummary: (payload: IViewFactFindRequest): APIResponse<IClientSummaryResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/ff/summary`, payload),

    // fact find financial planning
    viewFinancialPlanning: (payload: IViewFactFindFinancialPlanningRequest): APIResponse<IViewfactFindFinancialPlanningResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/financial/planning`, payload),

    captureFinancialPlanning: (payload: ICaptureFactFindFinancialPlanningRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/financial/planning`, payload),

    // fact find risk assessment
    viewRiskAssessment: (payload: IViewFactFindRiskAssessmentRequest): APIResponse<IViewFactFindRiskAssessmentResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/riskassessmentnotes/view`, payload),

    viewRiskAssessmentAnswers: (payload: IViewFactFindRiskAssessmentRequest): APIResponse<IViewFactFindRiskAssessmentAnswersResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/questionnaire/view`, payload),

    saveRiskAssessment: (payload: ICaptureFactFindRiskAssessmentRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/questionnaire/edit`, payload),

    deleteRiskAssessmentDocument: (payload: IDeleteRiskAssessmentDocumentPayload): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/questionnaire/document/delete`, payload),

    // registration house number lookup
    investorCompanyLookup: (payload: IInvestorCompanyLookupRequest): APIResponse<IInvestorcompanyLookupResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/business/company/lookup`, payload),

    // registration house number lookup
    getDefaultEnums: (payload: IEmptyRequestResponse): APIResponse<IDefaultEnumResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/business/view/default/enums`, payload),

    // registration house number lookup
    investorOfficerLookup: (payload: IInvestorCompanyLookupRequest): APIResponse<IInvestorCompanyOfficerLookupResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/business/company/officer/lookup`, payload),
    // experience
    captureExperience: (payload: ICaptureFactFindExperienceRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/experience`, payload),

    viewExperience: (payload: IViewFactFindRequest): APIResponse<IViewFactFindExperienceResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/experience`, payload),

    // personal info fact find
    viewFactFindEntity: (payload: FactFindInitRequest): APIResponse<FactFindEntityResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/viewbyid`, payload),

    capturePersonalDetails: (payload: ICaptureFactFindPersonalDetailsRequest): APIResponse<IViewFactFindPersonalDetailsRequest> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/factfind/save`, payload),

    // income
    viewIncome: (payload: IViewFactFindRequest): APIResponse<IViewFactFindIncomeResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/income`, payload),

    captureIncome: (payload: ICaptureFactFindIncomeRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/income`, payload),

    // expenditure
    viewExpenditure: (payload: IViewFactFindRequest): APIResponse<IViewFactFindExpenditureResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/expenditure`, payload),

    captureExpenditure: (payload: ICaptureFactFindExpenditureRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/expenditure`, payload),

    // liabilities
    viewLiabilities: (payload: IViewFactFindRequest): APIResponse<ILiabilitiesFactFindResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/liabilities`, payload),

    captureLiabilities: (payload: ILiabilitiesCapturePayload): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/liabilities`, payload),

    // health details - fact find
    viewHealthDetails: (payload: IViewFactFindRequest): APIResponse<IHealthDetailsApiResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/medicalinfo`, payload),

    captureHealthDetails: (payload: IHealthInfoPayloadRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/medicalinfo`, payload),

    // investment solution - fact find
    viewInvestmentSolutions: (payload: IViewFactFindRequest): APIResponse<IInvestmentSolutionsResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/investment/solution`, payload),

    captureInvestmentSolutions: (payload: IInvestmentSolutionCaptureRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/investment/solution`, payload),

    // protection solution - fact find
    viewProtectionSolutions: (payload: IViewFactFindRequest): APIResponse<IProtectionSolutionsResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/protection/solution`, payload),

    captureProtectionSolutions: (payload: IProtectionSolutionCaptureRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/protection/solution`, payload),

    // benefits and insurance - fact find
    viewBenefitsAndInsurance: (payload: IViewFactFindRequest): APIResponse<IBenefitsAndInsuranceResponseApiResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/insurance`, payload),

    captureBenefitsAndInsurance: (payload: IBenefitsAndInsurancePayload): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/insurance`, payload),

    // assets - fact find
    viewAssets: (payload: IViewFactFindRequest): APIResponse<IAssetResponseApi> => HttpClient.post(`${INVESTOR_SERVICE}/investor/view/assets`, payload),

    captureAssets: (payload: IAssetPayload): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/assets`, payload),

    viewGdpr: (payload: IViewGDPRPayload): APIResponse<IViewGDPRResponse> => HttpClient.post(`${INVESTOR_SERVICE}/investor/gdpr/view`, payload),

    acceptGdpr: (payload: IViewGDPRPayload): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${INVESTOR_SERVICE}/investor/gdpr/accept`, payload),

    resendGdpr: (payload: IViewGDPRPayload): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${INVESTOR_SERVICE}/investor/gdpr/resend`, payload),

    acceptEmailGdpr: (payload: IViewGDPRPayload): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/gdpr/email/accept`, payload),

    acceptInvite: (payload: IAcceptInviteRequest): APIResponse<IAcceptInviteResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/invitation/accept`, payload),

    getSourceDetail: (payload: ISourceDetailRequest): APIResponse<ISourceDetailResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/ff/sourcecontrol/view`, payload),

    viewFinancialPlanList: (payload: IViewFinancialPlanListRequest): APIResponse<IViewFinancialPlanListResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/financialplanlist`, payload),

    viewClientGoal: (payload: IViewClientGoalRequest): APIResponse<IViewClientGoalResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/clientgoal`, payload),

    captureClientGoal: (payload: ICaptureClientGoalRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/clientgoal`, payload),

    captureSuitabilityReportSetting: (payload: ICaptureSuitabilityReportSettingRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/capture/suitabilityreportsetting`, payload),

    viewSuitabilityReportSetting: (payload: IViewClientGoalRequest): APIResponse<IViewSuitabilityReportSettingResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/suitabilityreportsetting`, payload),

    generatePlanSummary: (payload: IGeneratePlanSummaryRequest): APIResponse<IGeneratePlanSummaryResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/generate/plansummary`, payload),

    // client portal
    saveRiskQuestionnaire: (payload: ISaveRiskQuestionnaireRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/questionnaire/save`, payload),

    ffSummaryCalculate: (payload: IFFSummaryCalculateRequest): APIResponse<IFFSummaryCalculateResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/section/summary/calcualte`, payload),

    saveRiskQuestionnairePublic: (payload: ISaveRiskQuestionnairePublicRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/public/questionnaire/save`, payload),

    viewRiskQuestionnaireGDPRPublic: (payload: IViewRiskQuestionnaireGDPRPublicRequest): APIResponse<IViewRiskQuestionnaireGDPRPublicResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/view/rtq/gdpr/session/info`, payload),

    viewFactfindDefaultChecklist: (payload: IEmptyRequestResponse): APIResponse<IViewFactfindDefaultChecklistResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/ff/default/checklist`, payload),

    captureFactfindChecklist: (payload: ICaptureFactfindCHecklistRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/ff/checklist/capture`, payload),

    viewFactfindChecklist: (payload: IViewFactfindChecklistRequest): APIResponse<IViewFactfindChecklistResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/ff/checklist/view`, payload),

    viewFinancialGoals: (payload: IViewFactFindFinancialPlanningRequest): APIResponse<IViewFinancialGoalsResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/financial-goal/view`, payload),

    saveFinancialGoals: (payload: ISaveFinancialGoalRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/financial-goal/save`, payload),

    // FF Business - Business Details
    viewBusinessDetails: (payload: IViewBusinessDetailsRequest): APIResponse<IBusinessDetailsResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/businessdetails`, payload),

    captureBusinessDetails: (payload: ISaveBusinessDetailsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/businessdetails`, payload),

    // FF Business - Key Members
    viewKeyMembers: (payload: IViewKeyMembersRequest): APIResponse<IKeyMembersResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/keyperson`, payload),

    captureKeyMembers: (payload: ISaveKeyMembersRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/keyperson`, payload),

    getQuestions: (payload: IGetQuestionsRequest): APIResponse<IGetQuestionsResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/list/questions`, payload),

    // FF Business - Financial Information
    viewFinancialInformation: (payload: IViewFinancialInformationRequest): APIResponse<IFinancialInformationResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/financialinfo`, payload),

    captureFinancialInformation: (payload: ISaveFinancialInformationRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/financialinfo`, payload),

    // FF Business - Loans
    viewLoans: (payload: IViewLoansRequest): APIResponse<IViewLoansResponse> => HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/loans`, payload),

    captureLoans: (payload: ISaveLoansRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/loans`, payload),

    // FF Business - Assets Premise
    viewAssetsPremise: (payload: IViewAssetsPremiseRequest): APIResponse<IViewAssetsPremiseResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/assetpremise`, payload),

    captureAssetsPremise: (payload: ISaveAssetsPremiseRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/assetpremise`, payload),

    // FF Business - Professional Advisors
    viewProfessionalAdvisors: (payload: IViewProfessionalAdvisorsRequest): APIResponse<IViewProfessionalAdvisorsResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/professionaladvisors`, payload),

    captureProfessionalAdvisors: (payload: ISaveProfessionalAdvisorsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/professionaladvisors`, payload),

    // Business FF Calls
    viewPensions: (payload: IViewFFPensionRequest): APIResponse<IViewFFPensionResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/pensions`, payload),

    createPensions: (payload: ICreatePensionsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/pensions`, payload),

    viewCovers: (payload: IViewFFCoversRequest): APIResponse<IViewFFCoversResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/existingcovers`, payload),

    createCovers: (payload: ICreateFFCoversRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/existingcovers`, payload),

    viewEmployeeBenefits: (payload: ICreateFFCoversRequest): APIResponse<IViewFFEmployeeBenefitsResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/view/employeebenefits`, payload),

    createEmployeeBenefits: (payload: ICreateFFEmployeeBenefitsRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/create/employeebenefits`, payload),

    //Business Ownership
    getBusinessOwnershipDetails: (payload: { clientID: string }): APIResponse<IGetBusinessOwnershipDetailsResponse> =>
      HttpClient.post(`${CLIENT_ADVICE_SERVICE}/business/ownership/display`, payload),

    inviteExistingClient: (payload: IInviteExistingClientRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/existing/invite`, payload),

    agreeMigration: (payload: { sessionToken: string }): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${INVESTOR_SERVICE}/investor/migration/consent/agree`, payload),

    initiateKYC: (payload: any): APIResponse<IEmptyRequestResponse> => HttpClient.post(`${INVESTOR_SERVICE}/investor/kyc/initiate`, payload),

    viewKYC: (payload: { clientID: string }): Promise<IViewAMLKYCResponse> => HttpClient.post(`${INVESTOR_SERVICE}/investor/amlkyc/view`, payload),

    // Client-level Fees
    createInvestorFee: (payload: unknown) => HttpClient.post(`${INVESTOR_SERVICE}/investor/fee/create`, payload),
    viewInvestorFees: (payload: { caseID: string }) => HttpClient.post(`${INVESTOR_SERVICE}/investor/fee/view`, payload),
    batchApproveInvestorFees: (payload: { caseID: string; ids: string[] }) => HttpClient.post(`${INVESTOR_SERVICE}/investor/fee/batch/approve`, payload),

    // Invoices
    searchInvestorInvoices: (payload: { caseID: string }) => HttpClient.post(`${INVESTOR_SERVICE}/investor/invoice/search`, payload),
    generateInvestorInvoices: (payload: { caseID: string; ids: string[] }) => HttpClient.post(`${INVESTOR_SERVICE}/investor/invoice/generate`, payload),
    calculateInvestorInvoices: (payload: { caseID: string; ids: string[] }) => HttpClient.post(`${INVESTOR_SERVICE}/investor/invoice/calculate`, payload),
    editInvestorFee: (payload: Record<string, unknown>) => HttpClient.post(`${INVESTOR_SERVICE}/investor/fee/edit`, payload),
  };
};
